export default {"src":"/_next/static/media/location.b6ba63bb.svg","height":12,"width":10,"blurWidth":0,"blurHeight":0};